// Katalog klientów: osoby, które zrobiły check-in lub mają dane do faktury.
export const clientesDir = {
  title: "Klienci",
  subtitle: "Wszystkie osoby, które zrobiły check-in lub mają dane do faktury. Są zapisywane automatycznie i nigdy się nie dublują.",
  searchLabel: "Szukaj klienta",
  searchPlaceholder: "Imię i nazwisko, dokument, e-mail lub telefon",
  filters: {
    todos: "Wszyscy",
    checkin: "Z check-inem",
    fiscal: "Z danymi podatkowymi",
    reservas: "Z rezerwacjami",
  },
  cols: {
    client: "Klient",
    document: "Dokument",
    phone: "Telefon",
    stays: "Pobyty",
    lastStay: "Ostatni pobyt",
  },
  checkins: "{n} check-in | {n} check-iny",
  bookings: "{n} rezerwacja | {n} rezerwacje",
  fiscalBadge: "Podatki",
  noDocument: "Brak dokumentu",
  noName: "Bez nazwy",
  emptyTitle: "Brak klientów",
  emptyText: "Każda osoba, która zakończy check-in, pojawi się tutaj automatycznie.",
  emptySearch: "Żaden klient nie pasuje do „{q}”.",
  loadError: "Nie udało się załadować klientów.",
  pageOf: "{from}–{to} z {total}",
  prev: "Poprzednia",
  next: "Następna",
  docTypes: {
    P: "Paszport",
    ID: "Krajowy dowód tożsamości",
    IM: "NIE",
    I: "Dowód osobisty",
    D: "Krajowy dowód tożsamości",
    N: "NIE",
    X: "Karta pobytu",
    CC: "Karta obywatelstwa",
    CE: "Karta cudzoziemca",
    TI: "Dowód tożsamości",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Zamknij",
    createBooking: "Utwórz rezerwację",
    personal: "Dane osobowe",
    document: "Dokument",
    address: "Adres",
    fiscal: "Dane podatkowe",
    noFiscal: "Brak danych podatkowych. Dodaje się je podczas fakturowania lub w sekcji Fakturowanie → Klienci podatkowi.",
    defaultProfile: "Domyślny",
    bookings: "Rezerwacje",
    noBookings: "Brak powiązanych rezerwacji.",
    companions: "Podróżował(a) z",
    noCompanions: "Nie dzielił(a) rezerwacji z nikim innym.",
    timesTogether: "{n} raz | {n} razy",
    invoices: "Faktury",
    noInvoices: "Brak faktur.",
    viewPdf: "Zobacz PDF",
    email: "E-mail",
    phone: "Telefon",
    birthDate: "Data urodzenia",
    sex: "Płeć",
    nationality: "Narodowość",
    docType: "Typ",
    docNumber: "Numer",
    expiry: "Ważny do",
    support: "Numer pomocniczy",
    street: "Adres",
    zip: "Kod pocztowy",
    city: "Miasto",
    country: "Kraj zamieszkania",
    roleCheckin: "Check-in",
    roleHolder: "Posiadacz",
    loadError: "Nie udało się otworzyć karty klienta.",
  },
  sexes: {
    M: "Mężczyzna",
    F: "Kobieta",
  },
  picker: {
    missingPolice: "Dla tego klienta nie ma zapisanych danych dla policji na tym koncie. Uzupełnij je teraz, a zostaną na następny raz.",
    searchSaved: "Szukaj zapisanego klienta",
    searchPlaceholder: "Imię i nazwisko, dokument lub telefon…",
    noResults: "Żaden zapisany klient nie pasuje.",
    selected: "Dane uzupełnione z sekcji Klienci",
    clear: "Usuń",
  },
  match: {
    title: "Ten klient już istnieje",
    text: "{name} jest już zapisany(a) w sekcji Klienci. Możesz uzupełnić wszystkie dane jednym dotknięciem.",
    use: "Użyj danych",
    dismiss: "To nie ta osoba",
    applied: "Uzupełniono dane: {name}. Sprawdź daty pobytu i podpisz.",
    companionsTitle: "Wcześniej podróżował(a) z",
    companionsHint: "Dotknij osoby, aby zarejestrować ją z jej danymi.",
    registerCompanion: "Zarejestruj: {name}",
  },
};
